export var ReportViewMode;
(function (ReportViewMode) {
    ReportViewMode[ReportViewMode["Data"] = 2] = "Data";
    ReportViewMode[ReportViewMode["Matrix"] = 4] = "Matrix";
    ReportViewMode[ReportViewMode["DataAndMatrix"] = 6] = "DataAndMatrix";
    ReportViewMode[ReportViewMode["Charts"] = 8] = "Charts";
    ReportViewMode[ReportViewMode["DataAndCharts"] = 10] = "DataAndCharts";
    ReportViewMode[ReportViewMode["MatrixAndCharts"] = 12] = "MatrixAndCharts";
    ReportViewMode[ReportViewMode["All"] = 238] = "All";
})(ReportViewMode || (ReportViewMode = {}));
;
